/**
 * Drift UI configuration constants.
 *
 * Centralises all external URLs and UI defaults for the drift tab so
 * no component needs to hardcode them.
 */

export const JIRA_BROWSE_URL = 'https://bloophing.atlassian.net/browse';
export const GITHUB_ORG_URL = 'https://github.com/Blooph-inc';

export const DRIFT_DEFAULT_FROM = 'dev';
export const DRIFT_DEFAULT_TO = 'prod';

export const DRIFT_ENV_PAIRS = [
  { from: 'dev',   to: 'prod'  },
  { from: 'dev',   to: 'stage' },
  { from: 'stage', to: 'prod'  },
  { from: 'stage', to: 'dev'   },
  { from: 'prod',  to: 'stage' },
  { from: 'prod',  to: 'dev'   },
] as const;

/**
 * Environment value accepted by GET /drift.
 *
 * Note: this differs from the dashboard's global `Environment` type
 * (`'dev' | 'staging' | 'prod'` in src/types/api.ts) which uses 'staging'
 * for historical reasons. The drift API and spec both use 'stage'. The
 * `getDrift()` signature type-guards this at compile time — TS will
 * reject an accidental `'staging'` passed as `DriftEnv`.
 */
export type DriftEnv = 'dev' | 'stage' | 'prod';
export type DriftEnvPair = (typeof DRIFT_ENV_PAIRS)[number];
